import { render, staticRenderFns } from "./IAM08.vue?vue&type=template&id=5286f988"
import script from "./IAM08.vue?vue&type=script&lang=js"
export * from "./IAM08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports